import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-mobile-container" }
const _hoisted_2 = {
  key: 0,
  class: "before-form"
}
const _hoisted_3 = { class: "edit-form" }
const _hoisted_4 = { class: "edit-form-item" }
const _hoisted_5 = { class: "dialog-container" }
const _hoisted_6 = { class: "dialog-title" }
const _hoisted_7 = { class: "dialog-title-tip" }
const _hoisted_8 = { class: "dialog-show-content" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "variable-value-container-mobile"
}
const _hoisted_12 = { class: "variable-value-label-mobile" }
const _hoisted_13 = { class: "variable-value" }
const _hoisted_14 = {
  key: 0,
  class: "button-container"
}
const _hoisted_15 = {
  key: 1,
  class: "before-form"
}
const _hoisted_16 = { class: "icon-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputMobile = _resolveComponent("InputMobile")!
  const _component_RadioMobile = _resolveComponent("RadioMobile")!
  const _component_FormPopup = _resolveComponent("FormPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.props.payload.nodeStatus !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            src: $setup.iconForm,
            width: "60px",
            height: "60px",
            style: {"margin":"5px 4px"}
          }, null, 8, ["src"]),
          _createElementVNode("div", {
            class: _normalizeClass($setup.props.payload.nodeStatus === 1 ? 'form-button-disable': 'form-button'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clickShowDialog && $setup.clickShowDialog(...args)))
          }, _toDisplayString($setup.TUITranslateService.t("AIDesk.立即填写")), 3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FormPopup, {
          class: "form-item",
          show: $setup.showDialog,
          showHeaderCloseButton: false,
          onOnClose: $setup.closeDialog,
          title: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.props.payload.content.tip), 1),
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeDialog && $setup.closeDialog(...args)))
                }, [
                  _createVNode(_component_Icon, {
                    src: $setup.iconClose,
                    width: "16px",
                    height: "16px"
                  }, null, 8, ["src"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.payload.content.inputVariables, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    (item.formType == 0 && $setup.props.payload.nodeStatus == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_InputMobile, {
                            placeholder: item.placeholder,
                            variableValue: item.variableValue,
                            name: item.name,
                            isRequired: item.isRequired,
                            onInputChange: $setup.handleInputChange,
                            validator: item.isRequired == 1 && $setup.isValid(item.name)
                          }, null, 8, ["placeholder", "variableValue", "name", "isRequired", "onInputChange", "validator"])
                        ]))
                      : (item.formType == 1 && $setup.props.payload.nodeStatus == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_RadioMobile, {
                              chooseItemList: item.chooseItemList,
                              name: item.name,
                              isRequired: item.isRequired,
                              onInputChange: $setup.handleInputChange,
                              validator: item.isRequired == 1 && $setup.isValid(item.name)
                            }, null, 8, ["chooseItemList", "name", "isRequired", "onInputChange", "validator"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(item.variableValue == '' ||  item.variableValue == null ? $setup.mapValue[item.name] : item.variableValue), 1)
                          ]))
                  ]))
                }), 128))
              ]),
              ($setup.props.payload.nodeStatus === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleSendForm && $setup.handleSendForm(...args)))
                    }, _toDisplayString($setup.TUITranslateService.t("AIDesk.提交")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["show", "onOnClose"])
      ])
    ]),
    ($setup.props.payload.nodeStatus == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_Icon, {
              class: "form-icon",
              src: $setup.iconForm,
              width: "60px",
              height: "60px",
              style: {"margin":"5px 4px"}
            }, null, 8, ["src"]),
            ($setup.props.payload.nodeStatus == 2)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  class: "form-icon-check",
                  width: "26px",
                  height: "26px",
                  src: $setup.iconFormFilled
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "form-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.clickShowDialog && $setup.clickShowDialog(...args)))
          }, _toDisplayString($setup.TUITranslateService.t("AIDesk.查看内容")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}